define(['../services/leads', '../../site/services/settings'], function () {
    'use strict';

    return {
        name: 'leadsCtrl',
        arguments: [
            '$http',
            '$rootScope',
            '$scope',
            '$state',
            '$stateParams',
            '$timeout',
            '$window',
            'ErrorHandler',
            'FileUpload',
            'Campaigns',
            'Leads',
            'Profile',
            'Settings',
            'Site',
            function (
                $http,
                $rootScope,
                $scope,
                $state,
                $stateParams,
                $timeout,
                $window,
                ErrorHandler,
                FileUpload,
                Campaigns,
                Leads,
                Profile,
                Settings,
                Site
            ) {
                $scope.settings = Settings.getSettings();
                $scope.currentLead = Leads.newLead();
                $scope.leadCounts = Leads.getLeadCounts();
                if (!$scope.leadFilter) {
                    $scope.leadFilter = 'complete';
                    $rootScope.leadFilter = 'complete';
                } else {
                    var presetFilter = true;
                }
                $scope.site = Site.getSite();
                $scope.user = Profile.getProfile();
                $scope.visibleColumns = [
                    'name',
                    'address',
                    'status',
                    'phone',
                    'email',
                ];

                $scope.$on('user-updated', function () {
                    $scope.user = Profile.getProfile();
                });
                $scope.settings.$promise.then(function (data) {
                    if (
                        data.options.hasOwnProperty('leadColumns') &&
                        data.options.leadColumns
                    ) {
                        var columns = JSON.parse(data.options.leadColumns);
                        if (columns) {
                            $scope.visibleColumns = columns;
                        }
                    }
                });

                if (
                    !$window.google ||
                    !$window.google.maps ||
                    !!$window.google.maps.places
                ) {
                    var script = document.createElement('script');
                    script.src =
                        '//maps.googleapis.com/maps/api/js?v=quarterly&key=' +
                        $window.google_maps_key +
                        '&libraries=places';
                    document.body.appendChild(script);
                }

                if ($stateParams) {
                    if ($stateParams.lead) {
                        $scope.currentLead = Leads.get(
                            $stateParams.lead,
                            function (lead) {
                                if (lead.new) {
                                    lead.new = false;
                                    lead.save(function () {
                                        Leads.updateLeadCounts();
                                    });
                                }
                            }
                        );
                    } else if (!$stateParams.f) {
                        $scope.leadCounts.$promise.then(function (counts) {
                            if (parseInt(counts.current.new) > 0) {
                                $scope.leadFilter = 'new';
                                $rootScope.leadFilter = 'new';
                            }
                        });
                    }
                    if ($stateParams.f) {
                        $rootScope.leadFilter = $stateParams.f;
                        $scope.leadFilter = $stateParams.f;
                    }
                }

                // Settings for pagination
                $scope.pagination = {
                    currentPage: 1,
                    perPage: 10,
                    items: false,
                };

                $scope.$watch('pagination.currentPage', function (
                    newValue,
                    oldValue
                ) {
                    if (!$scope.pagination.items || newValue != oldValue) {
                        $scope.loadLeads();
                    }
                });

                // Insitute a short delay so typing quickly doesn't send a ton of requests
                var searchTimeout = false;
                $scope.$watch('searchQuery', function (newValue, oldValue) {
                    if (newValue != oldValue) {
                        if (searchTimeout) {
                            $timeout.cancel(searchTimeout);
                        }
                        searchTimeout = $timeout(function () {
                            $scope.loadLeads();
                            searchTimeout = false;
                        }, 500);
                    }
                });

                $scope.pagination.currentPage = 1;

                $scope.showLeadLoading = false;
                $scope.loadLeads = function () {
                    $scope.showLeadLoading = true;
                    // Reload all leads with filters, pagination, etc
                    var filter = {
                        filter: $scope.leadFilter.toLowerCase(),
                        limit: $scope.pagination.perPage,
                        order: $scope.listOrder,
                        offset:
                            ($scope.pagination.currentPage - 1) *
                            $scope.pagination.perPage,
                        search: $scope.searchQuery,
                        'searchFields[]': $scope.visibleColumns,
                    };
                    $scope.pagination.items = Leads.getLeads(
                        filter,
                        function () {
                            $scope.showLeadLoading = false;
                        },
                        true
                    );

                    Leads.updateLeadCounts(filter);
                };

                $scope.listOrder = '-created';
                $scope.changeOrder = function (newOrder) {
                    if ($scope.listOrder == newOrder) {
                        $scope.listOrder = '-' + newOrder;
                    } else {
                        $scope.listOrder = newOrder;
                    }
                    $scope.loadLeads();
                };

                $scope.listLabels = {
                    name: 'Name',
                    address: 'Address',
                    status: 'Status',
                    phone: 'Phone',
                    email: 'Email',
                    timeFrame: 'Time Frame',
                    condition: 'Condition',
                    type: 'Type',
                    details: 'Detail',
                    dynamicCityUrl: 'Landing Page',
                    source: 'Lead Source',
                    created: 'Lead Added',
                    sendAutomatedEmails: 'Email subscription',
                };

                $scope.toggleColumn = function (columnId) {
                    var currentIndex = $scope.visibleColumns.indexOf(columnId);
                    if (currentIndex >= 0) {
                        $scope.visibleColumns.splice(currentIndex, 1);
                    } else {
                        $scope.visibleColumns.push(columnId);

                        $scope.visibleColumns.sort(function (a, b) {
                            var order = Object.keys($scope.listLabels);
                            return order.indexOf(a) - order.indexOf(b);
                        });
                    }

                    $scope.settings.options.leadColumns = JSON.stringify(
                        $scope.visibleColumns
                    );
                    $scope.settings.$update();
                };

                $scope.deleteCurrentLead = function () {
                    Leads.deleteLead($scope.currentLead, function () {
                        Leads.updateLeadCounts();
                        $state.go('leads.list');
                    });
                };

                $scope.leadsSelected = function () {
                    for (var i = 0; i < $scope.pagination.items.length; i++) {
                        if ($scope.pagination.items[i].isSelected) {
                            return true;
                        }
                    }
                    return false;
                };
                $scope.deleteSelectedLeads = function () {
                    for (var i = 0; i < $scope.pagination.items.length; i++) {
                        if ($scope.pagination.items[i].isSelected) {
                            Leads.deleteLead(
                                $scope.pagination.items[i],
                                function () {
                                    $scope.loadLeads();
                                }
                            );
                            i--;
                        }
                    }
                };

                $scope.saveCurrentLead = function (leadForm) {
                    leadForm.submitted = true;
                    if (leadForm.$valid) {
                        var success = true;
                        $scope.currentLead
                            .save()
                            .catch(function (result) {
                                if (leadForm) {
                                    leadForm.serverErrors = ErrorHandler.getMessage(
                                        result,
                                        'Error saving contact.  Please try again'
                                    );
                                }
                                success = false;
                            })
                            .then(function (result) {
                                if (success) {
                                    if ($scope.pagination.items) {
                                        $scope.loadLeads();
                                    }
                                    if (leadForm) {
                                        leadForm.submitted = false;
                                        leadForm.serverErrors = false;
                                    }
                                    Leads.updateLeadCounts();
                                    $state.go('leads.list');
                                }
                            });
                    }
                };

                $scope.updateLead = function (lead) {
                    lead.save();
                };

                $scope.sendCampaignToLead = function (campaignForm, modalId) {
                    campaignForm.submitted = true;
                    $scope.sendingSms = true;
                    $scope.buttonText = 'Sending';
                    if (campaignForm.$valid) {
                        var success = true;
                        var data = {};
                        data.campaign = $scope.currentCampaign;
                        data.sendTo = [$scope.currentLead.id];
                        Campaigns.sendCampaign(data)
                            .$promise.catch(function (result) {
                                if (campaignForm) {
                                    campaignForm.serverErrors = ErrorHandler.getMessage(
                                        result,
                                        'Error sending.  Please try again'
                                    );
                                    $scope.sendingSms = false;
                                    $scope.buttonText = 'Send SMS Message';
                                }
                                success = false;
                            })
                            .then(function (result) {
                                if (success) {
                                    if (modalId) {
                                        $scope.sendingSms = false;
                                        $scope.sentSms = true;
                                        $scope.buttonText = 'Sent';
                                        $timeout(function () {
                                            $('#' + modalId).foundation(
                                                'reveal',
                                                'close'
                                            );
                                        }, 350);
                                        $timeout(function () {
                                            $scope.buttonText =
                                                'Send SMS Message';
                                            $scope.sentSms = false;
                                        }, 1000);
                                    }
                                }
                            });
                    }
                };
                $scope.characterCount = function () {
                    if ($scope.currentCampaign.body) {
                        return (
                            $scope.currentCampaign.body.replace(
                                /\{ ?\$name ?\}/g,
                                ''
                            ).length +
                            (
                                $scope.currentCampaign.body.match(
                                    /\{ ?\$name ?\}/g
                                ) || []
                            ).length *
                                15
                        );
                    }
                    return 0;
                };

                $scope.setCurrentLead = function (lead) {
                    $scope.currentLead = lead;
                };

                $scope.requestAutoInformation = function () {
                    $http.get(
                        $rootScope.Routing.generate(
                            'request_autocomplete_leads'
                        )
                    );
                    $scope.moreLeadsInterest = true;
                };

                $scope.leadImportLoading = false;
                $scope.leadImportCount = null;
                $scope.leadImportErrors = [];
                $scope.onLeadFileSelected = function ($event, $files) {
                    $scope.leadImportLoading = true;
                    $scope.leadImportCount = null;
                    $scope.leadImportErrors = [];
                    angular.forEach($files, function (file) {
                        if (
                            file.type === 'text/csv' ||
                            file.name.endsWith('.csv')
                        ) {
                            FileUpload.uploadLeads(file)
                                .then((result) => {
                                    $scope.leadImportCount =
                                        result.data.successCount;
                                })
                                .catch((result) => {
                                    if (
                                        result.data &&
                                        result.data.error &&
                                        result.data.error.details
                                    ) {
                                        const details = JSON.parse(
                                            result.data.error.details
                                        );
                                        $scope.leadImportCount =
                                            details.successCount;
                                        $scope.leadImportErrors =
                                            details.errors;
                                    } else {
                                        $scope.leadImportErrors = ErrorHandler.getMessage(
                                            result,
                                            'Your import failed.  Please try again.'
                                        );
                                    }
                                })
                                .finally(() => {
                                    $scope.leadImportLoading = false;
                                    $scope.loadLeads();
                                });
                        } else {
                            $scope.leadImportErrors = [
                                'Only .csv files are supported.',
                            ];
                            $scope.leadImportLoading = false;
                        }
                    });
                    $event.target.value = '';
                };
            },
        ],
    };
});
